const r = {
  color: {
    information: "#7e8e9eff",
    range: "#314351ff",
    button: {
      default: "#7e8e9eff",
      hover: "#253642ff",
      background: "transparent",
      borderColor: "transparent",
      hoverBackground: "#f1f3f5ff",
      hoverBorderColor: "#f1f3f5ff",
      disabledBackground: "transparent",
      disabledBorderColor: "transparent"
    }
  }
};
export {
  r as pagination
};
